(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-editorial-hero]').forEach((hero) => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-editorial-slide]')];
      const controls = hero.querySelector('[data-editorial-controls]');
      const indicators = [...hero.querySelectorAll('[data-editorial-index]')];
      const status = hero.querySelector('[data-editorial-status]');
      let active = 0;
      let requested = 0;
      let revision = 0;
      let gesture = null;
      let suppressClick = false;
      if (slides.length < 2) return;
      controls.hidden = false;
      const preload = () => slides.slice(1).forEach((slide) => {
        slide.querySelector('img').loading = 'eager';
      });
      const firstImage = slides[0].querySelector('img');
      if (firstImage.complete) preload();
      else firstImage.addEventListener('load', preload, { once: true });
      const show = async (index) => {
        requested = (index + slides.length) % slides.length;
        const next = requested;
        const currentRevision = ++revision;
        const nextImage = slides[next].querySelector('img');
        nextImage.loading = 'eager';
        try { await nextImage.decode(); } catch {
          if (currentRevision === revision) status.textContent = hero.dataset.loadError;
          return;
        }
        if (currentRevision !== revision) return;
        active = next;
        slides.forEach((slide, i) => {
          slide.hidden = i !== active;
          slide.inert = i !== active;
        });
        indicators.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
        status.textContent = `${active + 1} / ${slides.length} — ${slides[active].dataset.title}`;
      };
      hero.addEventListener('click', (event) => {
        if (suppressClick) {
          event.preventDefault();
          suppressClick = false;
          return;
        }
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-editorial-index')) show(Number(button.dataset.editorialIndex));
        if (button.hasAttribute('data-editorial-direction')) show(requested + Number(button.dataset.editorialDirection));
      });
      hero.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        if (event.target.closest('input, textarea, select')) return;
        event.preventDefault();
        if (slides[active].contains(document.activeElement)) hero.focus({ preventScroll: true });
        show(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : requested + (event.key === 'ArrowRight' ? 1 : -1));
      });
      hero.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (!event.isPrimary || event.button !== 0 || event.target.closest('button, a')) return;
        gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
        hero.setPointerCapture(event.pointerId);
      });
      hero.addEventListener('pointerup', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          suppressClick = true;
          show(requested + (dx < 0 ? 1 : -1));
        }
      });
      hero.addEventListener('pointercancel', () => { gesture = null; });
      hero.addEventListener('lostpointercapture', () => { gesture = null; });
      hero.addEventListener('dragstart', (event) => event.preventDefault());
      hero.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
        if (index >= 0) show(index);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
